import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn,FaYoutube } from "react-icons/fa";
import "./footer.scss";


const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-header">
          <img src='/arrowdigital.png' alt="Company Logo" className="company-logo" />
        </div>
        <div className="footer-widgets">
          <div className="widget">
            <h4>About Us</h4>
            <p>
              We are dedicated to providing the best products and services. Our
              mission is to bring innovation to your doorstep.
            </p>
          </div>
          <div className="widget">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/home">Home</a></li>
              <li><a href="/aboutus">About</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/casestudies">Case Studies</a></li>
              {/* <li><a href="/contact">Contact</a></li> */}
              <li><a href="/privacypolicy">Privacy Policy</a></li>
              <li><a href="/termandcondition">Term & Condition</a></li>
              <li><a href="/shippinganddeliverypolicy">Shipping and Delivery</a></li>
              <li><a href="/refundpolicy">Refund Policy</a></li>
            </ul>
          </div>
          <div className="widget">
            <h4>Contact Us</h4>
            <p>Email: info@arrowdigitalmarketing.com</p>
            <p>Phone: +91 8527730069</p>
            <p>Address: 906-A, Advant navis business park, Noida-201305</p>
          </div>
          <div className="widget">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a href="https://www.facebook.com/ArrowDigitalAU" className="icon facebook">
                <FaFacebookF />
              </a>
              <a href="https://x.com/arrowdigital_" className="icon twitter">
                <FaTwitter />
              </a>
              <a href="https://www.instagram.com/arrowdigital_com/" className="icon instagram">
                <FaInstagram />
              </a>
              <a href="https://www.youtube.com/@Arrow.digital.marketing" className="icon youtube">
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Arrow Digital. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
